import { useState, SyntheticEvent } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';
import { logger } from '@/services/logger/logger';
import { clearErrorMessage } from '@/features/paymentProcess/transactionSlice';
import ProviderSelectSingle from '@/features/paymentSelect/ProviderSelectSingle';
import SoftHider from '@/components/softHider/SoftHider';
import Loader from '@/components/loader/Loader';
import PageHeader from '@/components/pageHeader/PageHeader';
import paymentTextContent from '@/features/paymentSelect/paymentTextContent';

import StepBack from '@/components/stepBack/StepBack';

function DirectPaymentSelect() {
  const dispatch = useAppDispatch();
  const paymentSelectState = useAppSelector(state => state.paymentSelect);
  const currentJourney = useAppSelector(state => state.journeys.journey);
  const successUrl = useAppSelector(state => state.transaction.successUrl);

  const [processing, setProcessing] = useState(false);

  const journeyNavigate = useJourneyNavigate();

  const onSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    if (!paymentSelectState.provider) {
      logger.error('No provider selected');
      return;
    }

    dispatch(clearErrorMessage());
    journeyNavigate('next');
  };

  return (
    <SoftHider show={!processing} loader={<Loader />}>

      <form onSubmit={event => void onSubmit(event)}>
        <PageHeader
          currentStep={1}
          totalSteps={4}
          headerText="Select a payment method"
          initialText={paymentTextContent.initialTextDirectPayment}
          currencySymbol="£"
        />

        <ProviderSelectSingle
          setProcessing={setProcessing}
        />
      </form>

      <StepBack isFirstJourneyStep currentJourney={currentJourney} successUrl={successUrl} />

    </SoftHider>
  );
}

export default DirectPaymentSelect;
